import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Home | Mining and Hydraulics",
  description = "Mining and Hydraulics - Providing the Australian Mining industry with custom oil & fuel filtration solutions. Factory appointed sole distributor of CC Jensen filtration systems.",
  keywords = "mining hydraulics, oil filtration, fuel filtration, CC Jensen, Australian mining, hydraulic systems, filtration equipment",
  image = "https://yourwebsite.com.au/logo.png",
  url = "https://yourwebsite.com.au/",
  type = "website",
  structuredData = null
}) => {
  const siteName = "Mining and Hydraulics";
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Mining and Hydraulics" />
      <meta name="robots" content="index, follow" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_AU" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
